import './styles.scss'

import React, { forwardRef } from 'react'

const CLASS_NAME = `generic-button`

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...rest }, ref) => {
    const classNames = [className, CLASS_NAME].filter((n) => n !== undefined)
    return (
      <button ref={ref} className={classNames.join(' ')} {...rest}>
        {children}
      </button>
    )
  },
)
